import React from "react";
import { useCustomerModel } from "../baseCustomerModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";


export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useCustomerModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            // placeholder: "客户名称",
            placeholder: Locale["Customer"],
            fieldName: "name"
        },
        {
            type: SearchTypeEnum.Input,
            // placeholder: "联系人",
            placeholder: Locale["Contact"],
            fieldName: "contact"
        },
        {
            type: SearchTypeEnum.Input,
            // placeholder: "联系电话",
            placeholder: Locale["Contact Number"],
            fieldName: "phone"
        },
        {
            type: SearchTypeEnum.Select,
            // placeholder: "客户状态",
            placeholder: Locale["Status"],
            fieldName: "enable",
            options: [{ label: Locale["open"], value: 1 }, { label: Locale["close"], value: 0 }]
        },
    ]
    const PageHeaderTitle = <>
    <span style={{ color: "#7F7F7F" }}>{Locale["Basic Data"]} </span>
    <span style={{ color: "#000" }}>/ {Locale["Customer Management"]}</span>
</>
    return (
        <YhPageHeader
            title={PageHeaderTitle}
            justify="end"
            triggerSearch={true}
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    );
}